export const SetLocalDelegacao = (delegacao) => localStorage.setItem('delegacao', delegacao)

export const GetLocalDelegacao = () => localStorage.getItem('delegacao')

export const DeleteLocalDelegacao = () => localStorage.removeItem('delegacao')
